import React from "react";
import "./styles.css";
const Badge = ({ children, type = "default", floatRight }) => (
  <div className={`Badge Badge--${type} ${floatRight && "Badge--float"}`}>{children}</div>
);
export default Badge;
export { Badge };
